import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormsDataService } from "@app/forms/services/forms-data.service";
import { IdNameCombination } from "@models/generic/IdNameCombination";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { FormStatusComponent } from "./status-overview/form-status.component";
import { FormPermissionModel } from "@models/permissions/FormPermissionModel";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "form-home",
    templateUrl: "./form-home.component.html",
    styleUrls: ["./form-home.component.scss"],
    standalone: false
})
export class FormHomeComponent implements OnInit {
    private _formDS = inject(FormsDataService);
    private permService = inject(PermissionsService);

    @ViewChild("status") status: FormStatusComponent;

    tab: TabModel;

    categories: IdNameCombination[];
    permissions = new FormPermissionModel();

    constructor() {
        this.permissions = this.permService.permissions.Forms;
    }

    async ngOnInit() {
        this.categories = await firstValueFrom(this._formDS.getOverviewCategories());
        this.tab.showLoader = false;
    }
}
